module.exports = __webpack_public_path__ + "img/bk_09.8dba8b41.png";